export var TILE_IDS = {
  EMBEDDING: 'embedding',
  HEATMAP: 'heatmap',
  LISTS: 'lists',
  CELLSETS: 'cellsets'
};
var initialState = {
  windows: {
    direction: 'row',
    first: {
      first: {
        first: TILE_IDS.EMBEDDING,
        second: TILE_IDS.CELLSETS,
        direction: 'row',
        splitPercentage: 60
      },
      second: TILE_IDS.HEATMAP,
      direction: 'column',
      splitPercentage: 50
    },
    second: TILE_IDS.LISTS,
    splitPercentage: 60
  },
  panel: 'Gene list'
};
export default initialState;